import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { Typography } from "@mui/material";
import { usePhones } from "./hooks/usePhones.js";
import { withPhoneMenuProviders } from "./phone-menu.providers.js";
import { PhoneMenu as PhoneMenu$1, PhoneItem } from "./phone-menu.styles.js";
import { usePhoneMenuProvider } from "./providers/PhoneMenuProvider.js";
import "@tanstack/react-query";
import "./api/phones.js";
import "./helpers/common.js";
import "./helpers/time.js";
import "./providers/AxiosProvider.js";
import "axios";
import "../../../constants/create-theme/create-theme.js";
import "@mui/material/styles";
import "../../../constants/colors/palette.js";
import "../../../themes/shadows/shadows.js";
import "../../../themes/typography/typography.js";
import "../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "../../../themes/button/button.js";
import "../../../themes/button/styles/external/bordered.styles.js";
import "color-alpha";
import "../../../themes/button/styles/external/filled.styles.js";
import "../../../themes/button/styles/internal/bordered.styles.js";
import "../../../themes/button/styles/internal/borderless.styles.js";
import "../../../themes/button/styles/internal/filled.styles.js";
import "../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../themes/dialog/dialog.js";
import "../../../themes/external-theme/external-theme.js";
import "../../../constants/breakpoints/breakpoints.js";
import "../../../themes/alert/alert.js";
import "../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../themes/checkbox/checkbox.js";
import "../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../themes/form-control-label/form-control-label.js";
import "../../../themes/radio/radio.js";
import "../../../themes/switch/switch.js";
import "../../../themes/pickers-popper/pickers-popper.js";
const PhoneMenuComponent = () => {
  const { anchorEl, phones: phonesFromProps, clinicReferenceId, onCall, onClose } = usePhoneMenuProvider();
  const { data: phonesFromQuery } = usePhones(phonesFromProps !== void 0, clinicReferenceId);
  const phoneArray = useMemo(() => phonesFromProps ?? phonesFromQuery ?? [], [phonesFromProps, phonesFromQuery]);
  const handlePhoneClick = (phone) => () => {
    onCall(phone);
  };
  return /* @__PURE__ */ jsx(
    PhoneMenu$1,
    {
      id: "call-patient-phones",
      anchorEl,
      keepMounted: true,
      open: Boolean(anchorEl),
      onClose,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "right"
      },
      children: phoneArray.map((phone) => /* @__PURE__ */ jsx(PhoneItem, { disabled: !phone, onClick: handlePhoneClick(phone), children: /* @__PURE__ */ jsx(Typography, { variant: "Lato Body 1", children: phone.name }) }, phone == null ? void 0 : phone.referenceId))
    }
  );
};
const PhoneMenu = withPhoneMenuProviders(PhoneMenuComponent);
export {
  PhoneMenu
};
